import { CLAUSE_KEYWORD_BOUNDARY } from '../configs';

export interface IBuildShowQueryParams {
  metrics: string[];
}

const build = (metrics: string[]) => `SHOW ${metrics.join(', ')}`;

const parse = (query: string): string[] => {
  const match = query.match(
    new RegExp(`\\bSHOW\\s+([\\s\\S]+?)(?=\\s+(?:${CLAUSE_KEYWORD_BOUNDARY})\\b)`, 'i'),
  );
  if (!match) return [];
  return match[1]
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
};

export { build as buildShowQuery, parse as parseShowQuery };
